import { createSelector, Selector, State, StateContext } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { IdNamePair } from '../../@models/index';
import { Injectable, Injector } from '@angular/core';
import { ContactService } from '../../@services/contacts.service';
import { DropdownService } from '../../@services';
import { ENDPOINTS } from 'src/app/@config/endpoints';

@State<IdNamePair[]>({
  name: 'opportunityPhase',
  defaults: []
})
@Injectable()
export class OpportunityPhaseState {

  private static service: DropdownService

  static hasAny() {
    return createSelector([OpportunityPhaseState], (state: IdNamePair[]) => {
      return state.length > 0;
    });
  }

  static getNameById(id: number) {
    return createSelector([OpportunityPhaseState], (state: IdNamePair[]) => {
      return state.find((item: IdNamePair) => item.id === id).name;
    });
  }

  constructor(injector: Injector) {
    OpportunityPhaseState.service = injector.get(DropdownService);
  }

  @Receiver()
  static loadAll({ setState }: StateContext<OpportunityPhaseState>) {
    this.service.getDropdownData(ENDPOINTS.getOpportunityPhaseList()).subscribe(
      (data: IdNamePair[]) => {
        setState(data);
      }
    );
  }

  static getPhase(id: number) {
    return createSelector([OpportunityPhaseState], (state: IdNamePair[]) => {
      return state.find((entry: IdNamePair) => entry.id === id);
    })
  }

}
